import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import moment from 'moment';

import { Text } from '../../../../components/Text';
import InfoVeiculoEdicao from './infoVeiculoEdicao';
import { TitleSections } from '../../../../components/TitleSections';
import { useAuth } from '../../../../hooks/auth';

export default function InfoVeiculoLeitura({
  item,
  index,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const [readOnly, setReadOnly] = useState(true);
  const [isAdministrador, setIsAdministrador] = useState(false);
  const { temPermissao } = useAuth();
  const tituloSecao = item?.detalheTipoCadastro;
  const preposition = tituloSecao === 'Cavalo' ? 'do' : 'da';

  useEffect(() => {
    const isAdmin =
      temPermissao(['EditarCadastroPainel']) && tipoValidacao === 1;
    setIsAdministrador(isAdmin);
  }, [temPermissao]);

  return (
    <>
      <TitleSections
        title={`Dados cadastrais ${preposition} ${tituloSecao} `}
        withButton={!!isAdministrador}
        buttonText="Editar"
        readOnly={readOnly}
        setReadOnly={setReadOnly}
      />
      {readOnly ? (
        <Col span={24} style={{ margin: '24px 0' }} key={index}>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Placa" value={item?.placa || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Renavam" value={item?.renavam || '-'} />
            </Col>
            <Col span={8}>
              {' '}
              <Text title="Chassi" value={item?.chassi || '-'} />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Marca" value={item?.marca || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Modelo" value={item?.modelo || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Carroceria" value={item?.carroceria || '-'} />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Cor" value={item?.cor || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Tipo" value={item?.tipo || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Ano fabricação" value={item?.anoFabricacao || '-'} />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Ano modelo" value={item?.anoModelo || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Número CRLV" value={item?.numeroCRLV || '-'} />
            </Col>
            <Col span={8}>
              <Text
                title="Data de licenciamento"
                value={
                  moment(item?.dataLicenciamento).format('DD/MM/YYYY') || '-'
                }
              />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text
                title="Cidade Licenciamento"
                value={item?.cidadeLicenciamento || '-'}
              />
            </Col>
          </Row>
        </Col>
      ) : (
        <InfoVeiculoEdicao
          item={item}
          index={index}
          setReadOnly={setReadOnly}
          carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          setSpinning={setSpinning}
        />
      )}
    </>
  );
}
